import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

interface Game {
  gameId: string;
  priority: any;
  gameDate: any;
  teams: string;
  status: any;
  links: string;
  createdAt: any;
  assignModerator: any;
  trackModeratorTime: any;
  lastStatusChangedAt: any;
  timer: any;
  empty: any;
  // Add other relevant fields here
}

import {
  Autocomplete,
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  Pagination,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  GAME_STATUS,
  hasRole,
  PERIOD_STATUS,
  PRIORITY,
  ROLE_IDS,
} from '../../../utils/constant';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import 'firebase/compat/firestore';
import useCommonDetails from '../../../hooks/useCommonDetails';
import GameRow from '../GameRow';
import GameTableRow from '../GameTableRow';
import SelectFilters from '../../SelectFilters';
import { visuallyHidden } from '@mui/utils';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import CloseIcon from '@mui/icons-material/Close';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalSearchContext } from '../../../context/GlobalSearchContext';
import { toast } from 'react-toastify';
import RefreshIcon from '@mui/icons-material/Refresh';
import { LoadingButton } from '@mui/lab';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
export default function GamesTable() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const surchIds = searchParams.get('gameId');

  const [games, setGames] = React.useState([]);
  const { _searchQuery: sQuery, _searchQueryTag: sQueryTag }: any =
    React.useContext(GlobalSearchContext);

  const currentUserInfo = useCommonDetails();
  const [openRowId, setOpenRowId] = React.useState<string | null>(null);
  const [loadingGames, setLoadingGames] = React.useState(false);
  const [loadingPeriod, setLoadingPeriod] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const itemsPerPage = 10;
  const [userInfo, setUserInfo] = React.useState<any[]>([]);
  const [moderatorInfo, setModeratorInfo] = React.useState<any>([]);
  const [periodList, setPeriodList] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [loadingRequest, setLoadingRequest] = React.useState(false);
  const [isTeamLoaded, setIsTeamLoaded] = React.useState(
    hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR, ROLE_IDS.TAGGER])
  );

  const [_searchQuery, _setSearchQuery] = React.useState<any>(
    surchIds
      ? surchIds
      : location.state?.searchGameId
        ? location.state.searchGameId
        : ''
  );

  const [debouncedQuery, setDebouncedQuery] = React.useState(_searchQuery);
  const [selectModrator, setSelectModerator] = React.useState<any[]>([]);
  const [selectAssign, setSelectAssign] = React.useState<any[]>([]);

  const [orderBy, setOrderBy] = React.useState<any>(null); // default sort by 'priority'
  const [order, setOrder] = React.useState<any>(null); // default sort order 'asc'
  const [selectStatus, setSelectStatus] = React.useState<string[]>(() => {
    if (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])) {
      return ['CREATED', 'IN_PROGRESS', 'IN_QC'];
    }

    if (hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR])) {
      return ['CREATED', 'IN_PROGRESS', 'IN_QC', 'UNDER_REVIEW', 'CANCELED'];
    }

    if (location.state?.status && location.state.status !== 'CORRECTION') {
      return [location.state.status];
    }

    return [];
  });
  const [selectPeriodStatus, setSelectPeriodStatus] = React.useState<string[]>(
    location.state?.status && location.state.status == 'CORRECTION'
      ? [location.state?.status]
      : []
  );
  const [selectPriority, setSelectPriority] = React.useState<any[]>([]);
  const [selectedPriorityKeys, setSelectedPriorityKeys] = useState<number[]>(
    []
  );
  const [teams, setTeams] = React.useState<any>([]);
  const [singleGameId, setSingleGameId] = useState('');
  const [selectedTeams, setSelectedTeams] = React.useState<any>([]);
  const [selectedTeamsKeys, setSelectedTeamsKeys] = React.useState<any[]>([]);
  const {
    fatchCurrentTaggingRequest,
    currentTaggingRequest,
    unassignedPeriodCount,
    unassignedPeriods,
  }: any = useContext(GlobalSearchContext);
  const { afterToday } = DateRangePicker;
  const ranges = [
    {
      label: 'Today',
      value: [new Date(), new Date()] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Yesterday',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 1)),
        new Date(new Date().setDate(new Date().getDate() - 1)),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Last 30 Days',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
  ];
  const [dateRangeReport, setDateRangeReport] = useState<[Date, Date]>([
    new Date(new Date().setDate(new Date().getDate() - 6)),
    new Date(),
  ]);
  //Fatch Current Tagging request for Get Toke(period)
  React.useEffect(() => {
    if (
      hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
      currentUserInfo.teamId === 3
    ) {
      fatchCurrentTaggingRequest();
    }
  }, [fatchCurrentTaggingRequest]);

  const sendTaggingRequest = async () => {
    try {
      setLoadingRequest(true);
      const response = await HttpService.post(API_ROUTES.sendTaggingRequest);
      toast.success('Request Send Successfully');
      fatchCurrentTaggingRequest();
      setLoadingRequest(false);
    } catch (error) {
      setLoadingRequest(false);
      console.error('Error fetching teams list:', error);
    }
  };

  const cancelTaggingRequest = async () => {
    try {
      setLoadingRequest(true);
      const response = await HttpService.patchRequest(
        API_ROUTES.cancelTaggingRequest
      );
      toast.success('Request Cancel Successfully');
      fatchCurrentTaggingRequest();
      setLoadingRequest(false);
    } catch (error) {
      setLoadingRequest(false);
      console.error('Error fetching teams list:', error);
    }
  };

  const fetchTeamsList = React.useCallback(async () => {
    try {
      const response = await HttpService.get(API_ROUTES.fatchAllTeam);
      const teamsData = response.data.data;
      setTeams(teamsData);

      // Select all teams except the one with id 1
      const defaultSelectedTeams = teamsData.filter(
        (team: any) => team.id !== 1
      );
      setIsTeamLoaded(true);
      setSelectedTeams(defaultSelectedTeams);
      setSelectedTeamsKeys(defaultSelectedTeams.map((team: any) => team.id));
    } catch (error: any) {
      setIsTeamLoaded(true);
      console.error('Error fetching teams list:', error);
    }
  }, []);

  // Call fetchTeamsList only once on component mount
  React.useEffect(() => {
    if (
      hasRole(currentUserInfo.roleId, [ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN])
    ) {
      fetchTeamsList();
    }
  }, [fetchTeamsList]);
  const handleChangeTeams = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectedTeams(newValue);
    const selectedKeys = newValue.map((option: any) => option.id);
    setSelectedTeamsKeys(selectedKeys);
  };
  const handleChangePriority = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectPriority(newValue);
    const selectedKeys = newValue.map((option: { key: number }) => option.key);
    setSelectedPriorityKeys(selectedKeys);
  };
  const handleChangeStaus = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectStatus(newValue);
  };

  const handleChangePeriodStaus = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectPeriodStatus(newValue);
  };

  const handleChangeModerator = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectModerator(newValue);
  };

  const handleChangeAssign = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectAssign(newValue);
  };

  const handleSearchChange = (e: any) => {
    setDebouncedQuery(e.target.value);
  };

  React.useEffect(() => {
    const timer = setTimeout(() => _setSearchQuery(debouncedQuery), 500);
    return () => clearTimeout(timer);
  }, [debouncedQuery]);
  const fetchUserModInfo = React.useCallback(async () => {
    try {
      // Filter users whose role includes "moderator"
      const resModerator: any = await HttpService.get(
        `${API_ROUTES.allUser}?roleId=1,2&search=${sQuery}`
      );

      setModeratorInfo(resModerator.data.data.list);
    } catch (error: any) {
      console.error('Error fetching user info:', error);
    }
  }, [sQuery]);
  const fetchTaggerModInfo = React.useCallback(async () => {
    try {
      const query: any = {
        roleId: 3,
        search: sQueryTag,
      };
      if (
        hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR]) &&
        currentUserInfo.teamId
      ) {
        query.teamId = currentUserInfo.teamId;
      }
      const resTagger: any = await HttpService.get(
        API_ROUTES.allUser + `?${new URLSearchParams(query).toString()}`
      );
      // Filter users whose role includes "user"
      setUserInfo(resTagger.data.data.list);
    } catch (error: any) {
      console.error('Error fetching Tagger info:', error);
    }
  }, [sQueryTag]);

  React.useEffect(() => {
    fetchUserModInfo();
  }, [fetchUserModInfo]);
  React.useEffect(() => {
    fetchTaggerModInfo();
  }, [fetchTaggerModInfo]);

  const fetchGamesList = React.useCallback(async () => {
    try {
      setLoadingGames(true);
      const query: any = {
        page: currentPage,
        limit: itemsPerPage,
      };
      if (surchIds) {
        query.search = surchIds;
      } else {
        query.search = _searchQuery;
      }
      if (orderBy && order) {
        (query.sortBy = orderBy), (query.orderBy = order);
      }
      if (selectedTeamsKeys.length > 0) {
        query.teamId = selectedTeamsKeys.join(',');
      }
      if (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])) {
        query.assignId = currentUserInfo.userId;
      } else if (hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR])) {
        query.userId = currentUserInfo.userId;
      }
      if (dateRangeReport) {
        query.startDate = moment(dateRangeReport[0]).format('DD-MM-YYYY');
        query.endDate = moment(dateRangeReport[1]).format('DD-MM-YYYY');
      }
      if (
        hasRole(currentUserInfo.roleId, [
          ROLE_IDS.ADMIN,
          ROLE_IDS.SUPER_ADMIN,
        ]) &&
        selectModrator.length > 0
      ) {
        query.userId = selectModrator?.map((value) => value.id).join(',');
      }

      if (
        hasRole(currentUserInfo.roleId, [
          ROLE_IDS.ADMIN,
          ROLE_IDS.SUPER_ADMIN,
          ROLE_IDS.MODERATOR,
        ])
      ) {
        if (selectAssign.length > 0) {
          query.assignId = selectAssign.map((value) => value.id).join(',');
        }
      }

      if (selectStatus.length > 0) {
        query.status = selectStatus.join(',');
      }
      if (selectPeriodStatus.length > 0) {
        query.periodStatus = selectPeriodStatus.join(',');
      }
      if (selectedPriorityKeys.length > 0) {
        query.priority = selectedPriorityKeys.join(',');
      }
      if (selectedTeamsKeys.length > 0) {
        query.teamId = selectedTeamsKeys.join(',');
      }
      const response = await HttpService.get(
        API_ROUTES.GamesList + `?${new URLSearchParams(query).toString()}`
      );
      setGames(response.data.data.list);
      setTotalPages(response.data.data.totalPages);
    } catch (error: any) {
      console.error('Error fetching games list:', error);
    } finally {
      setLoadingGames(false);
    }
  }, [
    currentPage,
    itemsPerPage,
    _searchQuery,
    selectModrator,
    selectedTeams,
    selectAssign,
    selectStatus,
    selectedPriorityKeys,
    selectPeriodStatus,
    isTeamLoaded,
    order,
    searchParams,
    dateRangeReport,
  ]);

  React.useEffect(() => {
    isTeamLoaded && fetchGamesList(); // Fetch data based on current page
  }, [fetchGamesList]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  const handleToggle = async (gameId: string) => {
    const isOpen = openRowId === gameId;
    if (isOpen) {
      // If the clicked accordion is already open, close it.
      setOpenRowId(null);
      setPeriodList([]); // Clear the periodList when closing the accordion.
    } else {
      // If a different accordion is being opened, set the new game ID.
      setOpenRowId(gameId);
      fetchPeriod(gameId);
      setPeriodList([]); // Clear the periodList to fetch new data.
    }
  };
  const fetchPeriod = async (gameId: string) => {
    try {
      const query: any = {
        gameId: gameId,
      };
      setLoadingPeriod(true);
      if (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])) {
        query.userId = currentUserInfo.userId;
      }

      if (selectAssign.length > 0) {
        query.userId = selectAssign.map((value) => value.id).join(',');
      }

      const response = await HttpService.get(
        API_ROUTES.PeriodList + `?${new URLSearchParams(query).toString()}`
      );
      setPeriodList(response.data.data.list || []);
    } catch (error: any) {
      console.error('Error fetching period list:', error);
    } finally {
      setLoadingPeriod(false);
    }
  };
  const handleApiToggle = React.useCallback(
    async (id: string) => {
      try {
        setLoadingPeriod(true);
        const query: any = {
          gameId: id,
        };
        setLoadingPeriod(true);
        if (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])) {
          query.userId = currentUserInfo.userId;
        }

        const response = await HttpService.get(
          API_ROUTES.PeriodList + `?${new URLSearchParams(query).toString()}`
        );
        setPeriodList(response.data.data.list || []);
      } catch (error: any) {
        console.error('Error fetching period list:', error);
      } finally {
        setLoadingPeriod(false);
      }
    },
    [selectAssign]
  );
  const fatchGame = async () => {
    try {
      setLoading(true);
      const response = await HttpService.get(`${API_ROUTES.fetchGame}`);
      fetchGamesList();
      setLoading(false);
    } catch (error: any) {
      console.error('Error fetching game :', error);
    } finally {
      setLoading(false);
    }
  };
  const fatchGameSingle = async () => {
    try {
      if (!singleGameId) {
        return;
      }
      setLoading(true);
      const response = await HttpService.get(
        `${API_ROUTES.fetchGame}/${singleGameId}`
      );
      fetchGamesList();
      setSingleGameId('');
      setLoading(false);
    } catch (error: any) {
      console.error('Error fetching game :', error);
    } finally {
      setLoading(false);
    }
  };

  const createSortHandler = (property: keyof Game) => () => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const clearFilter = () => {
    setSelectModerator([]);
    setSelectAssign([]);
    setSelectStatus([]);
    setSelectPriority([]);
    setSelectedPriorityKeys([]);
    setDebouncedQuery('');
    setSelectPeriodStatus([]);
    setSelectedTeams([]);
    setSelectedTeamsKeys([]);
    setIsTeamLoaded(true);
    navigate(PAGE_ROUTES.GAMES);
    setCurrentPage(1);
    setDateRangeReport([
      new Date(new Date().setDate(new Date().getDate() - 6)),
      new Date(),
    ]);
  };

  const priorityOptions = Object.entries(PRIORITY).map(([key, value]) => ({
    key: Number(key), // Convert key to a number
    label: value,
  }));

  const handleDateChangeReport = (value: any) => {
    setDateRangeReport(value);
  };
  return (
    <>
      <Box sx={{ display: 'block' }}></Box>
      {hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
        currentUserInfo.teamId === 3 && (
          <Box
            sx={{
              display: 'flex',
              padding: '5px',
              justifyContent: 'space-between',
              alignItems: 'center',
              border: '1px solid black',
              borderRadius: '5px',
            }}
          >
            <Box sx={{ display: 'flex', gap: 4 }}>
              <Typography variant="h6">
                Unassign Periods : {unassignedPeriods.totalCount}
              </Typography>
              <Box>
                <Tooltip title="Refresh For Unassign Periods Count">
                  <span>
                    <Button
                      onClick={() => unassignedPeriodCount()}
                      variant="contained"
                      color="info"
                      size="small"
                      disabled={loading}
                      sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <RefreshIcon />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Box>
            <Box>
              {' '}
              {currentTaggingRequest?.canCancel ? (
                <Box>
                  <LoadingButton
                    onClick={() => cancelTaggingRequest()}
                    variant="contained"
                    color="warning"
                    size="small"
                    loading={loadingRequest}
                    sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
                    startIcon={<CloseIcon />}
                  >
                    {'Cancel Token Request'}
                  </LoadingButton>
                </Box>
              ) : currentTaggingRequest?.hasAccess ? (
                <Box>
                  <LoadingButton
                    onClick={() => sendTaggingRequest()}
                    variant="contained"
                    color="info"
                    size="small"
                    loading={loadingRequest}
                    sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
                    startIcon={<PlaylistAddIcon />}
                  >
                    {'Request For Token'}
                  </LoadingButton>
                </Box>
              ) : null}
            </Box>
          </Box>
        )}

      <Box
        sx={{
          display: 'flex',
          padding: '20px 0',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={debouncedQuery}
            onChange={handleSearchChange}
            sx={{ width: '300px', height: '2.4375em !important' }} // Adjust the width as needed
          />

          <SelectFilters
            currentUserInfo={currentUserInfo}
            userInfo={userInfo}
            moderatorInfo={moderatorInfo}
            selectModrator={selectModrator}
            selectAssign={selectAssign}
            handleChangeModerator={handleChangeModerator}
            handleChangeAssign={handleChangeAssign}
          ></SelectFilters>
          {hasRole(currentUserInfo.roleId, [
            ROLE_IDS.ADMIN,
            ROLE_IDS.SUPER_ADMIN,
          ]) && (
            <FormControl sx={{ minWidth: 200 }}>
              <Autocomplete
                size="small"
                multiple
                fullWidth
                id="role-selector"
                options={teams}
                value={selectedTeams} // Replace with your selected roles state
                getOptionLabel={(option: any) => option.userTeamKey}
                onChange={(event, newValue) => {
                  handleChangeTeams(event, newValue); // Replace with your role change handler
                }}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Teams" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            </FormControl>
          )}
          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              fullWidth
              multiple
              id="tags-outlined"
              options={GAME_STATUS}
              value={selectStatus}
              getOptionLabel={(option) => option}
              onChange={(event, newValue: any) => {
                handleChangeStaus(event, newValue);
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Status" />
              )}
            />
          </FormControl>

          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              multiple
              fullWidth
              id="tags-outlined"
              options={priorityOptions}
              value={selectPriority}
              getOptionLabel={(option) => option.label}
              onChange={(event, newValue) => {
                handleChangePriority(event, newValue);
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Priority" />
              )}
              isOptionEqualToValue={(option, value) => option.key === value.key}
            />
          </FormControl>
          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              multiple
              fullWidth
              id="tags-outlined"
              options={PERIOD_STATUS}
              value={selectPeriodStatus}
              getOptionLabel={(option) => option}
              onChange={(event, newValue: any) => {
                handleChangePeriodStaus(event, newValue);
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Period Status" />
              )}
            />
          </FormControl>
          <DateRangePicker
            character=" – "
            size="lg"
            shouldDisableDate={afterToday()}
            onChange={handleDateChangeReport}
            value={dateRangeReport}
            ranges={ranges}
          />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              onClick={() => clearFilter()}
              variant="contained"
              sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            >
              Clear Filter
            </Button>
          </Box>
        </Box>
        {hasRole(currentUserInfo.roleId, [
          ROLE_IDS.ADMIN,
          ROLE_IDS.SUPER_ADMIN,
        ]) && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              size="small"
              onChange={(e) => setSingleGameId(e.target.value)}
              placeholder="Enter Game Id"
              value={singleGameId}
              sx={{ minWidth: 140 }}
            />
            <Box>
              <LoadingButton
                onClick={() => fatchGameSingle()}
                variant="contained"
                loading={loading}
                sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
              >
                Import Single Game
              </LoadingButton>
            </Box>
          </Box>
        )}
        {hasRole(currentUserInfo.roleId, [
          ROLE_IDS.ADMIN,
          ROLE_IDS.SUPER_ADMIN,
        ]) && (
          <Box sx={{ ml: 1 }}>
            <LoadingButton
              onClick={() => fatchGame()}
              variant="contained"
              loading={loading}
              sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            >
              Fetch Game
            </LoadingButton>
          </Box>
        )}
      </Box>

      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Game ID</TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'priority'}
                  direction={orderBy === 'priority' ? order : 'asc'}
                  onClick={createSortHandler('priority')}
                >
                  Priority
                  {orderBy === 'priority' ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell sx={{ minWidth: 190 }}>
                <TableSortLabel
                  active={orderBy === 'gameDate'}
                  direction={orderBy === 'gameDate' ? order : 'asc'}
                  onClick={createSortHandler('gameDate')}
                >
                  Date
                  {orderBy === 'gameDate' ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell sx={{ minWidth: 250 }}>Teams</TableCell>

              <TableCell align="left" sx={{ minWidth: 120 }}>
                Comments
              </TableCell>

              <TableCell sx={{ minWidth: 190 }}>
                <TableSortLabel
                  active={orderBy === 'createdAt'}
                  direction={orderBy === 'createdAt' ? order : 'asc'}
                  onClick={createSortHandler('createdAt')}
                >
                  Fetched
                  {orderBy === 'createdAt' ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell sx={{ minWidth: 190 }}>
                <TableSortLabel
                  active={orderBy === 'lastStatusChangedAt'}
                  direction={orderBy === 'lastStatusChangedAt' ? order : 'asc'}
                  onClick={createSortHandler('lastStatusChangedAt')}
                >
                  Status Change Time
                  {orderBy === 'lastStatusChangedAt' ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Links</TableCell>
              <TableCell>Assign Moderator</TableCell>
              <TableCell>Assign QC Moderator</TableCell>
              {!hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) && (
                <TableCell>Progress</TableCell>
              )}
              <TableCell>Status Timer</TableCell>
              <TableCell>Activity Log</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {games.map((row: any) => {
              const isOpen = openRowId === row.gameId;
              return (
                <React.Fragment key={row.gameId}>
                  <GameTableRow
                    row={row}
                    isOpen={isOpen}
                    fetchPeriod={() => fetchPeriod(row.gameId)}
                    handleToggle={handleToggle}
                    currentUserInfo={currentUserInfo}
                    moderatorInfo={moderatorInfo}
                    fetchGamesList={fetchGamesList}
                  />
                  <TableRow>
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={11}
                    >
                      <Collapse in={isOpen} timeout="auto" unmountOnExit>
                        <GameRow
                          gameData={row}
                          periodList={periodList}
                          userInfo={userInfo}
                          handleApiToggle={handleApiToggle}
                          fetchGamesList={fetchGamesList}
                          isPeriodOnly={true}
                        />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingGames || loadingPeriod}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
